module.exports = __webpack_public_path__ + "img/07.4a8248fd.png";